import React from "react"
import { useParams } from "react-router-dom"

import Button from "../button/Button"
// functions
import { getProject } from "../../Data"

import { Wrapper, Content } from "./CaseStudy.styles"

const CaseStudy = () => {
  const { title } = useParams()
  const project = getProject(title)

  return (
    <Wrapper>
      <Content>
        <h1>{project.title}</h1>
        <p className="stack">{project.stack}</p>
        <p className="justified">{project.description}</p>
        {project.code ? (
          <Button
            type="button"
            text="Code"
            callback={() => window.open(project.code, "_blank")}
          />
        ) : null}
        {project.link ? (
          <Button
            type="button"
            text="Link"
            callback={() => window.open(project.link, "_blank")}
          />
        ) : null}
      </Content>
    </Wrapper>
  )
}

export default CaseStudy
